export default __webpack_public_path__ + "static/media/MarsCentra-Bold.7b1ab15a.eot";